export default __webpack_public_path__ + "media/images/icon_bookmarks-630f834a9cdfcfbd0695b8378bb94272.png";